import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "realtime-traffic-table__content" }
const _hoisted_2 = { class: "realtime-traffic-table__basic" }
const _hoisted_3 = {
  id: "realtime-traffic-heading-basic",
  class: "realtime-traffic-table__heading__basic"
}
const _hoisted_4 = { class: "realtime-traffic-table__heading" }
const _hoisted_5 = {
  id: "realtime-traffic-cell-basic",
  class: "realtime-traffic-table__cell__basic"
}
const _hoisted_6 = { class: "realtime-traffic-table__option" }
const _hoisted_7 = {
  id: "realtime-traffic-heading-option",
  class: "realtime-traffic-table__heading__option"
}
const _hoisted_8 = { class: "realtime-traffic-table__heading" }
const _hoisted_9 = {
  id: "realtime-traffic-cell-option",
  class: "realtime-traffic-table__cell__option"
}

import { mapModifires, type typeModifires } from "@/components/utils/modifires";
import {
  withDefaults,
  Ref,
  ref,
  watch,
  onMounted,
} from "vue";
import { IRealTimeTrafficConvert } from "@/attribute/convert/IRealTimeTrafficConvert";
import { RealTimeTrafficAttributeView } from "@/attribute/convert/RealTimeTrafficAttributeView";

interface Props {
  modifires?: typeModifires;
  realTimeTrafficConvert: IRealTimeTrafficConvert;
  timeCode: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'realtime-traffic',
  props: {
    modifires: { type: [String, Array, Boolean] },
    realTimeTrafficConvert: {},
    timeCode: {}
  },
  emits: ["changeTitle"],
  setup(__props: any, { emit }) {

const props = __props;





/**
 * 基本テーブル表示ヘッダ
 */
const BASIC_TABLE_HEADERS = ["観測年月日", "時間帯"];

/**
 * テーブル表示ヘッダ
 */
const tableHeaders: Ref<Array<string>> = ref([]);

/**
 * 基本テーブル表示データ
 */
const basicTableValues: Ref<Array<Array<string>>> = ref([]);

/**
 * テーブル表示データ
 */
const tableValues: Ref<Array<Array<string>>> = ref([]);

/**
 * 日時更新処理
 */
const updateDate = async (timeCode: string) => {
  tableHeaders.value.length = 0;
  tableValues.value.length = 0;
  await props.realTimeTrafficConvert
    .load(
      timeCode.substring(0, 4) +
        "/" +
        timeCode.substring(4, 6) +
        "/" +
        timeCode.substring(6, 8) +
        " " +
        timeCode.substring(8, 10) +
        ":" +
        timeCode.substring(10, 12)
    )
    .then((res: RealTimeTrafficAttributeView) => {
      tableHeaders.value = res.realTimeAttributeRowHeader;
      basicTableValues.value = res.realTimeAttributeValues
        .reverse()
        .map((ele) => {
          let rowValue = [];
          rowValue.push(ele.headerDate);
          rowValue.push(ele.headerTime);
          return rowValue;
        });
      tableValues.value = res.realTimeAttributeValues.map((ele) => {
        return ele.attributeValues;
      });
      emit("changeTitle", res.title);
    });
};

/**
 * 時間コードwatch
 */
watch(
  () => props.timeCode,
  () => {
    updateDate(props.timeCode);
  },
  { immediate: true }
);

watch(
  () => props.realTimeTrafficConvert,
  () => {
    updateDate(props.timeCode);
  },
  { immediate: true }
);

/**
 * 初期処理
 */
onMounted(() => {
  const cellBasic = document.getElementById("realtime-traffic-cell-basic");
  const headingOption = document.getElementById(
    "realtime-traffic-heading-option"
  );
  const cellOption = document.getElementById("realtime-traffic-cell-option");
  cellBasic.addEventListener("scroll", () => {
    cellOption.scrollLeft = cellBasic.scrollLeft;
  });
  headingOption.addEventListener("scroll", () => {
    cellOption.scrollTop = headingOption.scrollTop;
  });
  cellOption.addEventListener("scroll", () => {
    cellBasic.scrollLeft = cellOption.scrollLeft;
    headingOption.scrollTop = cellOption.scrollTop;
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(mapModifires)('realtime-traffic-table', _ctx.modifires))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(BASIC_TABLE_HEADERS, (header, rowIndex) => {
              return _createElementVNode("div", {
                key: rowIndex,
                class: "realtime-traffic-table-row"
              }, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(header), 1)
              ])
            }), 64))
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(BASIC_TABLE_HEADERS, (_header, rowIndex) => {
              return _createElementVNode("div", {
                key: rowIndex,
                class: "realtime-traffic-table-row"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(basicTableValues.value, (value, columnIndex) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: rowIndex + '-' + columnIndex,
                    class: _normalizeClass(["realtime-traffic-table__cell", {
                  'realtime-traffic-table__cell__latest': columnIndex === 0,
                }])
                  }, _toDisplayString(value[rowIndex]), 3))
                }), 128))
              ])
            }), 64))
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tableHeaders.value, (header, rowIndex) => {
              return (_openBlock(), _createElementBlock("div", {
                key: rowIndex,
                class: "realtime-traffic-table-row"
              }, [
                _createElementVNode("div", _hoisted_8, _toDisplayString(header), 1)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tableHeaders.value, (_header, rowIndex) => {
              return (_openBlock(), _createElementBlock("div", {
                key: rowIndex,
                class: "realtime-traffic-table-row"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tableValues.value, (value, columnIndex) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: rowIndex + '-' + columnIndex,
                    class: _normalizeClass(["realtime-traffic-table__cell", {
                  'realtime-traffic-table__cell__latest': columnIndex === 0,
                }])
                  }, _toDisplayString(value[rowIndex]), 3))
                }), 128))
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ], 2))
}
}

})